<div *ngIf="loading" class="text-center p-3 text-muted">
  {{ "t-reload-history" | translate }}
</div>

<ng-container *ngIf="!loading">
  <ul class="nav nav-pills nav-custom-outline nav-primary rounded border-bottom-0 mb-3" role="tablist">
    <li class="nav-item">
      <a class="nav-link" role="tab" href="javascript:void(0)" [class.active]="filter === 'ALL'"
        (click)="setFilter('ALL')">
        {{ "t-all" | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" role="tab" href="javascript:void(0)" [class.active]="filter === 'BUYER'"
        (click)="setFilter('BUYER')">
        {{ "t-proposals.t-buyer" | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" role="tab" href="javascript:void(0)" [class.active]="filter === 'OWNER'"
        (click)="setFilter('OWNER')">
        {{ "t-lead-owner" | translate }}
      </a>
    </li>
  </ul>

  <ng-container *ngFor="let item of filteredItems; let last = last">
    <div class="acitivity-item d-flex mb-2 pb-2 p-2">
      <div class="flex-shrink-0 avatar-xs acitivity-avatar">
        <div class="avatar-title rounded-circle shadow" [ngClass]="{
            'bg-soft-primary text-primary': item.lead?.leadType === 'BUYER',
            'bg-soft-success text-success': item.lead?.leadType === 'OWNER',
            'bg-soft-info text-info':
              item.action?.icon && item.lead?.leadType !== 'BUYER' && item.lead?.leadType !== 'OWNER'
          }">
          <i *ngIf="item.action?.icon" [ngClass]="item.action.icon + ' fs-16'"></i>
          <i *ngIf="!item.action?.icon" [ngClass]="{
              'ri-user-received-2-line fs-16': item.lead?.leadType === 'BUYER',
              'ri-home-heart-line fs-16': item.lead?.leadType === 'OWNER'
            }"></i>
        </div>
      </div>

      <div class="flex-grow-1 ms-4">
        <div class="d-flex justify-content-between align-items-start">
          <h6 class="m-1 fs-16">
            {{ item.action?.name === 'NOTE' ? ('t-leads-m.t-note' | translate)
              : item.action?.translateKey === 'move'
                ? (getMoveTitle(item?.title) | translate: { value: item?.title?.toUpperCase() })
                : item.action?.name === 'FIRST CALL'
                  ? ('t-leads-m.t-first-contact' | translate)
                  : (item.title | translate) }}
          </h6>

          <span class="badge fs-12" [ngClass]="item.lead?.leadType === 'OWNER' ? 'badge-soft-success' : 'badge-soft-primary'">
            {{ item.lead?.leadType === 'BUYER' ? ('t-proposals.t-buyer' | translate) : ('t-lead-owner' | translate) }}
          </span>
        </div>

        <div class="text-muted small fs-14">
          <div *ngIf="item.userUpdated?.name">
            <i class="ri-user-line me-1"></i>{{ item.userUpdated.name }}
          </div>

          <div class="d-flex gap-1" *ngIf="item?.notes">
            <i class="fs-14 mdi mdi-text-long me-1"></i>
            <div [innerHTML]="item.notes"></div>
          </div>

          <div *ngIf="item.lead?.property?.reference">
            <i class="ri-map-pin-line me-1"></i>
            {{ "t-general.t-property-reference" | translate }}: {{ item.lead.property.reference }}
          </div>

          <div>
            <i class="ri-time-line me-1"></i>
            {{ "t-created-at" | translate }}: {{ formatDateWithHour(item.createdAt) }}
          </div>

          <div *ngIf="item.updatedAt !== item.createdAt">
            <i class="ri-refresh-line me-1"></i>
            {{ "t-m-properties.t-updated-at" | translate }}: {{ formatDateWithHour(item.updatedAt) }}
          </div>

          <div *ngIf="item.doneDate">
            <i class="ri-checkbox-circle-line me-1"></i>
            {{ "t-completed" | translate }}: {{ formatDateWithHour(item.doneDate) }}
          </div>
        </div>
      </div>
    </div>

    <hr *ngIf="!last" class="lead-divider" />
  </ng-container>

  <div class="py-4 text-center text-muted" *ngIf="filteredItems.length === 0">
    <i class="ri-inbox-line fs-24 d-block mb-2"></i>
    {{ "t-contact-overview.t-empty-activity" | translate }}
  </div>
</ng-container>
